import { Dispatch, SetStateAction } from 'react'
import { Observable } from 'rxjs'
import { APICompanySettingsResponse } from '../models'
import store from '../store'
import { ActionType } from '../store/error/actions'
import { useService } from '../utils/hook'
import request, { RequestResponse } from '../utils/request'

export function useSettings(): [
  RequestResponse<APICompanySettingsResponse[]> | undefined,
  Dispatch<SetStateAction<Record<string, string | number | undefined>>>,
  Observable<RequestResponse<APICompanySettingsResponse[]>> | undefined
] {
  return useService(
    () => request.getRequest('api/settings/')<APICompanySettingsResponse[]>(),
    {},
    (error) => {
      if (error instanceof DOMException) return
      store.dispatch({
        type: ActionType.SET_BY_STATUS,
        payload: { statusCode: error.status, message: error.message }
      })
    }
  )
}
